import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/AuthShell";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (!token) {
      toast.error("Missing reset token.");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/reset-password", { token, new_password: password });
      toast.success("Password reset. Sign in with your new one.");
      nav("/login");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthShell
      title="Choose a new password"
      subtitle="Make it stronger than your last."
      footer={<Link to="/login" className="text-amber-500 hover:text-amber-400 underline">Back to sign in</Link>}
    >
      <form onSubmit={submit} className="space-y-4 font-body" data-testid="reset-form">
        <label className="block">
          <span className="text-stone-400 text-sm mb-1 block">New password (6+ chars)</span>
          <input
            type="password"
            required
            minLength={6}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-stone-950 border border-stone-700 rounded px-3 py-2 focus:border-amber-600 outline-none"
            data-testid="reset-password"
          />
        </label>
        <button
          type="submit"
          disabled={submitting || !token}
          className="btn-gold w-full py-2.5 disabled:opacity-50"
          data-testid="reset-submit"
        >
          {submitting ? "Sealing…" : "Set new password"}
        </button>
        {!token && (
          <p className="text-red-400 text-sm">Reset token missing from URL.</p>
        )}
      </form>
    </AuthShell>
  );
}
